<div id="KpiTrendAllElements">
    <div id="KpiTrendCoachingHeader">
      <div>
        <cv-group-selector #groupSelectorDTOComp
          [showLabels]="false"
          [pageName]="moduleKey"
          [baseGroupType]="0"
          [settingsManager]="settingsManager"
          [specificLevel]="1"
          [hasMultiSelect]="true"
          [selectedGroupsDto]="selectedAgentsDTO"
          [selectAllOnEmpty]="false"
          (selectedGroupsChanged)="agentGroupsChanged($event)"
          (selectedGroupsLoaded)="initialGroupsLoaded($event)">
      </cv-group-selector>
      </div>
        <div>
            <table class="custom-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Performance trend</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let agent of tableData">
                        <td>
                            <img
                                [src]="'icon' + agent.id + '.png'"
                                [alt]="'Icon ' + agent.id"
                                title="agent.id"
                            />
                            {{ agent.name }}
                        </td>
                        <td>75% <span class="arrow-up"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div>Metric: {{ metricName }}</div>
</div>
